import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

/**
 * Catalog-graph APIs and entity content — native.
 * page:catalog-graph is enabled natively; we only override it to hide the
 * auto-rendered PluginHeader (`noHeader: true`).
 */
const catalogGraphFeature = catalogGraphPlugin.withOverrides({
  extensions: [
    catalogGraphPlugin.getExtension('page:catalog-graph').override({
      factory(originalFactory) {
        return originalFactory({
          params: { noHeader: true } as any,
        });
      },
    }),
  ],
});

export default catalogGraphFeature;
